import { Heading } from '@zillow/constellation-10';

import { EditListingTourConfigSteps } from '../../../constants/EditListingTourConfigModalConstants';

const getHeader = (step: EditListingTourConfigSteps) => {
  switch (step) {
    case EditListingTourConfigSteps.SET_BOOKING_METHOD:
    case EditListingTourConfigSteps.EDIT_BOOKING_METHOD:
      return 'Choose a way to book tours';
    case EditListingTourConfigSteps.SET_TIME_ZONE:
      return 'Select the property time zone';
    case EditListingTourConfigSteps.SET_TOUR_DURATION:
    case EditListingTourConfigSteps.EDIT_TOUR_DURATION:
      return 'Edit tour length';
    default:
      return 'When are you free for tours?';
  }
};

const EditListingTourConfigModalHeader = ({ step }: { step: EditListingTourConfigSteps }) => {
  return (
    <Heading level={4} data-testid="EditListingTourConfigModal-ModalHeader">
      {getHeader(step)}
    </Heading>
  );
};

export default EditListingTourConfigModalHeader;
